module.exports = __webpack_public_path__ + "static/media/DARK GREEN JOBS.6cc60f8d.svg";